export default function About() {
  return (
    <div id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <div className="inline-block">
              <span className="text-yellow-600 font-semibold text-sm uppercase tracking-wider">About Our Cleaning Company</span>
            </div>
            <h2 className="text-4xl font-bold text-gray-900 leading-tight">
              <strong>Trusted Cleaning Company Oman</strong> – <span className="text-yellow-500">Professional Cleaning Services</span> Across Muscat, Seeb &amp; Barka
            </h2>
            
            <h3 className="text-2xl font-semibold text-gray-800">
              Leading Professional Cleaning Services Oman for Homes &amp; Businesses
            </h3>
            
            <p className="text-lg text-gray-600 leading-relaxed">
              <strong>Cleaning Bees</strong> is Oman's premier <strong>professional cleaning company</strong> delivering exceptional <strong>cleaning services in Oman</strong> for residential and commercial properties. As a trusted <strong>cleaning company in Muscat</strong>, we specialize in comprehensive <strong>house cleaning Oman</strong>, <strong>office cleaning Oman</strong>, <strong>deep cleaning services</strong>, and <strong>villa cleaning</strong> across Muscat, Seeb, Barka, Mabela, Al Hail, Sohar, and Salalah.
            </p>
            
            <h4 className="text-xl font-semibold text-gray-800">
              Comprehensive Cleaning Services Oman Residents Trust
            </h4>
            
            <p className="text-lg text-gray-600 leading-relaxed">
              Our experienced team provides the best <strong>cleaning services Muscat</strong> has to offer, including <strong>residential cleaning Oman</strong>, <strong>commercial cleaning Oman</strong>, <strong>apartment cleaning</strong>, and specialized <strong>deep cleaning Oman</strong> solutions. We understand every space is unique, offering customized <strong>professional cleaning services Oman</strong> tailored to your specific needs.
            </p>
            
            <h5 className="text-xl font-semibold text-gray-800">
              Affordable Cleaning Services in Oman with Eco-Friendly Solutions
            </h5>
            
            <p className="text-lg text-gray-600 leading-relaxed">
              What sets us apart as a leading <strong>cleaning company in Oman</strong> is our commitment to using eco-friendly, safe cleaning products that protect your family, pets, and the environment. We combine professional expertise with <strong>affordable cleaning services Oman</strong> pricing to deliver guaranteed quality results. Whether you need daily, weekly, or monthly <strong>cleaning services in Oman</strong>, our reliable team serves you across all major cities.
            </p>
            
            <h6 className="text-lg font-semibold text-gray-800">
              Local Cleaning Experts Serving All Oman
            </h6>
            
            <p className="text-lg text-gray-600 leading-relaxed">
              As Oman local experts, we proudly serve communities throughout Muscat, Seeb, Barka, Sohar, and surrounding areas. Our comprehensive services include <strong>house cleaning services Oman</strong>, <strong>office cleaning services Oman</strong>, routine maintenance, specialized deep cleaning, carpet shampooing, marble polishing, pool maintenance, and pest control. Trust <strong>Cleaning Bees</strong> – your reliable <strong>cleaning company near me in Oman</strong> where quality meets reliability.
            </p>
            
            <div className="grid grid-cols-2 gap-4 pt-4">
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-yellow-600 text-sm"></i>
                </div>
                <span className="text-gray-700 font-medium">Reliable &amp; Experienced Team</span>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-yellow-600 text-sm"></i>
                </div>
                <span className="text-gray-700 font-medium">Eco-Friendly Products</span>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-yellow-600 text-sm"></i>
                </div>
                <span className="text-gray-700 font-medium">Affordable Pricing</span>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-yellow-600 text-sm"></i>
                </div>
                <span className="text-gray-700 font-medium">Guaranteed Quality</span>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-yellow-600 text-sm"></i>
                </div>
                <span className="text-gray-700 font-medium">Serving All Property Types</span>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-yellow-600 text-sm"></i>
                </div>
                <span className="text-gray-700 font-medium">Oman Local Experts</span>
              </div>
            </div>
          </div>

          <div className="relative space-y-6">
            <div className="grid grid-cols-2 gap-6">
              <div className="relative rounded-xl overflow-hidden shadow-lg">
                <div className="w-full h-56">
                  <img 
                    src="https://public.readdy.ai/ai/img_res/79e9870dddcceae0fbc457a545d5ef1c.jpg" 
                    alt="Professional cleaning equipment and eco-friendly products used by cleaning company Oman" 
                    title="Professional Cleaning Equipment - Cleaning Bees Oman"
                    loading="lazy"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              <div className="relative rounded-xl overflow-hidden shadow-lg">
                <div className="w-full h-56">
                  <img 
                    src="https://readdy.ai/api/search-image?query=satisfied%20customer%20smiling%20in%20clean%20bright%20modern%20home%20interior%20happy%20homeowner%20with%20professional%20cleaning%20service%20result%20white%20and%20yellow%20tones%20natural%20lighting%20pristine%20environment&width=400&height=350&seq=about-img-customer-001&orientation=portrait" 
                    alt="Satisfied customer with professional cleaning services Oman - happy client in Muscat" 
                    title="Happy Customers - Cleaning Services Oman"
                    loading="lazy"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>

            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <div className="w-full h-72">
                <img 
                  src="https://readdy.ai/api/search-image?query=professional%20cleaning%20team%20in%20yellow%20and%20black%20uniforms%20working%20together%20in%20a%20modern%20bright%20home%20with%20cleaning%20equipment%20and%20eco%20friendly%20products%20showing%20teamwork%20and%20professionalism%20clean%20white%20and%20yellow%20environment%20natural%20lighting&width=600&height=400&seq=about-img-team-001&orientation=landscape" 
                  alt="Professional cleaning company Oman team providing house cleaning and office cleaning services in Muscat" 
                  title="Cleaning Bees - Professional Cleaning Services Oman Team"
                  loading="lazy"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-yellow-900/20 to-transparent"></div>
            </div>

            <div className="grid grid-cols-2 gap-6">
              <div className="relative rounded-xl overflow-hidden shadow-lg">
                <div className="w-full h-56">
                  <img 
                    src="https://readdy.ai/api/search-image?query=modern%20clean%20bright%20home%20interior%20living%20room%20with%20spotless%20floors%20and%20furniture%20professional%20cleaning%20result%20white%20and%20yellow%20tones%20natural%20sunlight%20pristine%20environment&width=400&height=350&seq=about-img-home-001&orientation=portrait" 
                    alt="House cleaning services Oman - residential cleaning Muscat result" 
                    title="Professional House Cleaning Oman"
                    loading="lazy"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              <div className="relative rounded-xl overflow-hidden shadow-lg">
                <div className="w-full h-56">
                  <img 
                    src="https://readdy.ai/api/search-image?query=professional%20office%20workspace%20clean%20and%20organized%20modern%20business%20environment%20spotless%20desks%20and%20floors%20bright%20professional%20setting%20white%20and%20yellow%20accents&width=400&height=350&seq=about-img-office-001&orientation=portrait" 
                    alt="Office cleaning services Oman - commercial cleaning Muscat" 
                    title="Professional Office Cleaning Oman"
                    loading="lazy"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>

            <div className="absolute -bottom-6 -right-6 bg-yellow-500 text-black p-8 rounded-xl shadow-xl z-10">
              <div className="text-center">
                <div className="text-4xl font-bold">10+</div>
                <div className="text-sm mt-1">Years Experience</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}